import {classNames, PushButton, View} from "@variocube/cube-ui";
import * as React from "react";
import {useCallback, useState} from "react";
import {stylesheet} from "typestyle";
import {CodeDialog} from "./code";
import {Cleaner, CubeOrder} from "./model";

import background from "./video-screenshot1.png";
import {useLocalization} from "../i18n";

interface HomeViewProps {
    onCleaner: (cleaner: Cleaner) => void;
    onOrder: (order: CubeOrder) => void;
}

export function HomeView({onOrder, onCleaner}: HomeViewProps) {
    const {t} = useLocalization();
    const [open, setOpen] = useState(false);

    const handleOpen = useCallback(() => setOpen(true), []);
    const handleClose = useCallback(() => setOpen(false), []);

    return (
        <View className={classNames(styles.home)}>

            <div className={styles.startButtonContainer}>
                <PushButton primary onClick={handleOpen} className={styles.startButton}>
                    {t("LetsGo")}
                </PushButton>
            </div>

            <CodeDialog open={open}
                        onClose={handleClose}
                        onCleaner={onCleaner}
                        onOrder={onOrder}/>
        </View>
    );
}

const styles = stylesheet({
    home: {
        background: `var(--color-background) url("${background}") no-repeat center / cover`,
        // backgroundPosition: "cover",
        width: "100%",
        height: "100%",
    },
    startButtonContainer: {
        position: "absolute",
        bottom: "3em",
        left: "50%",
        transform: "translateX(-50%)"
    },
    startButton: {
        fontSize: "1.75em",
        boxShadow: "0px 1px 5px rgba(0,0,0,0.75)",
        border: "0.25rem solid #fff"
    }
});